// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-steps {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin: 0 0 2rem;
}

.reset-step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
}

.reset-step {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 2px solid rgba(247, 189, 32, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: var(--text-muted);
  background: #fff;
  transition: all 0.3s ease;
}

.reset-step.active {
  border-color: transparent;
  color: #1a1a1a;
  background: linear-gradient(135deg, #f7bd20, #f5a623);
  box-shadow: 0 10px 25px rgba(247, 189, 32, 0.3);
}

.reset-step.done {
  border-color: rgba(247, 189, 32, 0.5);
  color: var(--secondary);
  background: rgba(247, 189, 32, 0.15);
}

.reset-step-label {
  font-size: 0.75rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.reset-note {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin: 0.5rem 0 0;
}

.reset-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.3);
  color: #16a34a;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
}

.reset-success {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
  text-align: center;
  padding: 1rem 0;
}

.reset-success-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(34, 197, 94, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #16a34a;
}

.reset-login-btn {
  width: 100%;
  max-width: 280px;
  text-align: center;
}

@media (max-width: 768px) {
  .reset-steps {
    gap: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ForgotPasswordPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qDAAqD;EACrD,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,SAAS;EACX;AACF","sourcesContent":[".reset-steps {\n  display: flex;\n  justify-content: center;\n  gap: 1.5rem;\n  margin: 0 0 2rem;\n}\n\n.reset-step-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.reset-step {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 2px solid rgba(247, 189, 32, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  color: var(--text-muted);\n  background: #fff;\n  transition: all 0.3s ease;\n}\n\n.reset-step.active {\n  border-color: transparent;\n  color: #1a1a1a;\n  background: linear-gradient(135deg, #f7bd20, #f5a623);\n  box-shadow: 0 10px 25px rgba(247, 189, 32, 0.3);\n}\n\n.reset-step.done {\n  border-color: rgba(247, 189, 32, 0.5);\n  color: var(--secondary);\n  background: rgba(247, 189, 32, 0.15);\n}\n\n.reset-step-label {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.reset-note {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  margin: 0.5rem 0 0;\n}\n\n.reset-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: rgba(34, 197, 94, 0.1);\n  border: 1px solid rgba(34, 197, 94, 0.3);\n  color: #16a34a;\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  margin-bottom: 1.5rem;\n}\n\n.reset-success {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  align-items: center;\n  text-align: center;\n  padding: 1rem 0;\n}\n\n.reset-success-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: rgba(34, 197, 94, 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #16a34a;\n}\n\n.reset-login-btn {\n  width: 100%;\n  max-width: 280px;\n  text-align: center;\n}\n\n@media (max-width: 768px) {\n  .reset-steps {\n    gap: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
